/**
 * Interface for error.
 */
export interface IError {
    message: string | null;
};

/**
 * Interface for delete api's response.
 */
export interface IDeleteApiResponse {
    message: string;
    id: string;
}

export const enum ApiStatus {
    IDLE = "IDLE",
    LOADING = "LOADING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
}

export const enum apiLimit {
    limit= 10,
}

export const defaultRowsPerPageOptions = [10, 25, 50, 100]